/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * OpenAPI spec version: 1.32.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpContext }  from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AcceptSignupInvitationRequest } from '../model/acceptSignupInvitationRequest';
import { AccountInvolvements } from '../model/accountInvolvements';
import { AddFeedbackRequest } from '../model/addFeedbackRequest';
import { Categories } from '../model/categories';
import { Category } from '../model/category';
import { CharityCommunity } from '../model/charityCommunity';
import { ClientErrorResponse } from '../model/clientErrorResponse';
import { CommentPosition } from '../model/commentPosition';
import { Communities } from '../model/communities';
import { CommunitiesBasic } from '../model/communitiesBasic';
import { CommunityCounters } from '../model/communityCounters';
import { CommunityInviteOrDeclineRequest } from '../model/communityInviteOrDeclineRequest';
import { ConnectionRequestAction } from '../model/connectionRequestAction';
import { Connections } from '../model/connections';
import { ContextPreferences } from '../model/contextPreferences';
import { Conversation } from '../model/conversation';
import { CounselRole } from '../model/counselRole';
import { CounselUsersByType } from '../model/counselUsersByType';
import { CovidMapData } from '../model/covidMapData';
import { CovidVaccinationsMapData } from '../model/covidVaccinationsMapData';
import { CreateCategoryRequest } from '../model/createCategoryRequest';
import { CreateCharityRequest } from '../model/createCharityRequest';
import { CreateCommentRequest } from '../model/createCommentRequest';
import { CreateCommunityRequest } from '../model/createCommunityRequest';
import { CreateConversationRequest } from '../model/createConversationRequest';
import { CreateFolderRequest } from '../model/createFolderRequest';
import { CreateIndividualRequest } from '../model/createIndividualRequest';
import { CreateOrganizationRequest } from '../model/createOrganizationRequest';
import { CreatePostRequest } from '../model/createPostRequest';
import { CreateProjectRequest } from '../model/createProjectRequest';
import { CreateSubcategoryRequest } from '../model/createSubcategoryRequest';
import { DeactivatedUsersCounters } from '../model/deactivatedUsersCounters';
import { DeactivationBody } from '../model/deactivationBody';
import { DeactivationUpdateBody } from '../model/deactivationUpdateBody';
import { DoctorLinkRequests } from '../model/doctorLinkRequests';
import { DoctorPreferences } from '../model/doctorPreferences';
import { EmptyResponse } from '../model/emptyResponse';
import { ExtendedNotificationsContextPreferences } from '../model/extendedNotificationsContextPreferences';
import { FileActivityLog } from '../model/fileActivityLog';
import { FileDescriptor } from '../model/fileDescriptor';
import { FileSizeResponse } from '../model/fileSizeResponse';
import { FilesActivityLog } from '../model/filesActivityLog';
import { FolderDescriptor } from '../model/folderDescriptor';
import { FoldersResponse } from '../model/foldersResponse';
import { FullUser } from '../model/fullUser';
import { FullUserUpdateRequest } from '../model/fullUserUpdateRequest';
import { GenerateAuthenticatorSecretResponse } from '../model/generateAuthenticatorSecretResponse';
import { GenerateDownloadFileUrlResponse } from '../model/generateDownloadFileUrlResponse';
import { GenerateFileRequest } from '../model/generateFileRequest';
import { GenerateFileResponse } from '../model/generateFileResponse';
import { Health } from '../model/health';
import { HealthCommunity } from '../model/healthCommunity';
import { InlineResponse201 } from '../model/inlineResponse201';
import { ListOfBasicUsers } from '../model/listOfBasicUsers';
import { ListOfCommentReplies } from '../model/listOfCommentReplies';
import { ListOfExtendedUsers } from '../model/listOfExtendedUsers';
import { ListOfRootComments } from '../model/listOfRootComments';
import { LoginRequest } from '../model/loginRequest';
import { LoginResponse } from '../model/loginResponse';
import { MedicalDoctorLinksBody } from '../model/medicalDoctorLinksBody';
import { MedicalPatientLinksBody } from '../model/medicalPatientLinksBody';
import { MessagingAccessToken } from '../model/messagingAccessToken';
import { MessagingChannelBasic } from '../model/messagingChannelBasic';
import { NotificationsContextPreferences } from '../model/notificationsContextPreferences';
import { OtpAttemptStatus } from '../model/otpAttemptStatus';
import { OtpStatusResponse } from '../model/otpStatusResponse';
import { PaginatableDeactivationIncidents } from '../model/paginatableDeactivationIncidents';
import { PaginatableListOfAdmins } from '../model/paginatableListOfAdmins';
import { PaginatableListOfBasicUsers } from '../model/paginatableListOfBasicUsers';
import { PaginatableListOfExtendedUsers } from '../model/paginatableListOfExtendedUsers';
import { PaginatablePendingUserInvolvements } from '../model/paginatablePendingUserInvolvements';
import { PaginatablePendingUserInvolvementsInCommunities } from '../model/paginatablePendingUserInvolvementsInCommunities';
import { PaginatablePendingUserInvolvementsInProjects } from '../model/paginatablePendingUserInvolvementsInProjects';
import { PatientDistributionFilter } from '../model/patientDistributionFilter';
import { PatientLinkRequests } from '../model/patientLinkRequests';
import { PermissionErrorResponse } from '../model/permissionErrorResponse';
import { Post } from '../model/post';
import { Posts } from '../model/posts';
import { ProfileConnectionsBody } from '../model/profileConnectionsBody';
import { Project } from '../model/project';
import { ProjectInviteOrDeclineRequest } from '../model/projectInviteOrDeclineRequest';
import { Projects } from '../model/projects';
import { ProjectsBasic } from '../model/projectsBasic';
import { QueryMode } from '../model/queryMode';
import { ReactivationPetitionStatus } from '../model/reactivationPetitionStatus';
import { ReactivationPetitionUpdateBody } from '../model/reactivationPetitionUpdateBody';
import { RecentAction } from '../model/recentAction';
import { RelationGeography } from '../model/relationGeography';
import { ReplyComment } from '../model/replyComment';
import { ReplyCommentRequest } from '../model/replyCommentRequest';
import { RequestCounters } from '../model/requestCounters';
import { RequestCountersBasic } from '../model/requestCountersBasic';
import { RequestOneTimeCode } from '../model/requestOneTimeCode';
import { ResetPasswordBody } from '../model/resetPasswordBody';
import { ResetPasswordChangeBody } from '../model/resetPasswordChangeBody';
import { RootComment } from '../model/rootComment';
import { SearchAggregationResponse } from '../model/searchAggregationResponse';
import { SearchAttributesResponse } from '../model/searchAttributesResponse';
import { SearchResponse } from '../model/searchResponse';
import { SecureSession } from '../model/secureSession';
import { SendSignupInvitationRequest } from '../model/sendSignupInvitationRequest';
import { ShareRequest } from '../model/shareRequest';
import { SignupIndividualRequest } from '../model/signupIndividualRequest';
import { SignupOrganizationRequest } from '../model/signupOrganizationRequest';
import { SocialGroupCountersBasic } from '../model/socialGroupCountersBasic';
import { SortAttributeNames } from '../model/sortAttributeNames';
import { Statistics } from '../model/statistics';
import { SuggestionItemTypes } from '../model/suggestionItemTypes';
import { SuggestionResponse } from '../model/suggestionResponse';
import { UnshareFilesRequest } from '../model/unshareFilesRequest';
import { UpdateCategoryRequest } from '../model/updateCategoryRequest';
import { UpdateCharityRequest } from '../model/updateCharityRequest';
import { UpdateCommunityRequest } from '../model/updateCommunityRequest';
import { UpdateConversationTitleRequest } from '../model/updateConversationTitleRequest';
import { UpdateFileStorageItemRequest } from '../model/updateFileStorageItemRequest';
import { UpdatePostRequest } from '../model/updatePostRequest';
import { UpdateProjectRequest } from '../model/updateProjectRequest';
import { UserChangePassword } from '../model/userChangePassword';
import { UserId } from '../model/userId';
import { UserIdRequest } from '../model/userIdRequest';
import { UserSocialGroupsStats } from '../model/userSocialGroupsStats';
import { ValidateResetPasswordTokenBody } from '../model/validateResetPasswordTokenBody';
import { ValidateSignupInvitationTokenRequest } from '../model/validateSignupInvitationTokenRequest';
import { VerifyOneTimeCodeRequest } from '../model/verifyOneTimeCodeRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class DefaultService {

    protected basePath = 'https://localhost:8080';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Fetches all admins users
     * 
     * @param sorting Sorting order param, default is name_asc* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restAdminAdminListGet(sorting?: string, offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<PaginatableListOfAdmins> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatableListOfAdmins>(`${this.basePath}/admins`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Send signup invitation
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restAdminSendSignupInvitationPost(body: SendSignupInvitationRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restAdminSendSignupInvitationPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/admin/send_signup_invitation`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Accept signup invitation
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthAcceptSignupInvitationPost(body: AcceptSignupInvitationRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<UserId> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restAuthAcceptSignupInvitationPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<UserId>(`${this.basePath}/auth/accept_signup_invitation`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Unbind authenticator app from user
     * 
     
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthAuthenticatorDelete(httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/auth/authenticator`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Generate authenticator app secret for user
     * 
     
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthAuthenticatorPost(httpContext?: HttpContext, reportProgress?: boolean): Observable<GenerateAuthenticatorSecretResponse> {

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<GenerateAuthenticatorSecretResponse>(`${this.basePath}/auth/authenticator`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Create verified individual. Available only for admins.
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthCreateIndividualPost(body: CreateIndividualRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<UserId> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restAuthCreateIndividualPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<UserId>(`${this.basePath}/auth/create/individual`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Create verified organization. Available only for admins.
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthCreateOrganizationPost(body: CreateOrganizationRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<UserId> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restAuthCreateOrganizationPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<UserId>(`${this.basePath}/auth/create/organization`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View the system&#x27;s deactivation incidents, admin only
     * 
     * @param reactivation_petition_status Status of reactivation petition* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthDeactivateIndex(reactivation_petition_status?: ReactivationPetitionStatus, offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<PaginatableDeactivationIncidents> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (reactivation_petition_status !== undefined && reactivation_petition_status !== null) {
            queryParameters = queryParameters.set('reactivation_petition_status', <any>reactivation_petition_status);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatableDeactivationIncidents>(`${this.basePath}/auth/deactivate/deactivation_incidents`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Deactivate a user&#x27;s account, admin only.
     * 
     * @param body * @param userId User ID
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthDeactivatePost(body: DeactivationBody, userId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<EmptyResponse> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restAuthDeactivatePost.');
        }

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restAuthDeactivatePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EmptyResponse>(`${this.basePath}/auth/${encodeURIComponent(String(userId))}/deactivate`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Modify a user&#x27;s deactivation incident, admin only
     * 
     * @param body * @param userId User ID
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthDeactivatePut(body: DeactivationUpdateBody, userId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<EmptyResponse> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restAuthDeactivatePut.');
        }

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restAuthDeactivatePut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<EmptyResponse>(`${this.basePath}/auth/${encodeURIComponent(String(userId))}/deactivate`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Modify a reactivation petition
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthDeactivatePutReactivationPetition(body: ReactivationPetitionUpdateBody, httpContext?: HttpContext, reportProgress?: boolean): Observable<EmptyResponse> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restAuthDeactivatePutReactivationPetition.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<EmptyResponse>(`${this.basePath}/auth/deactivate/petition`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Get counters for deactivated users
     * 
     
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthDeactivatedUsersCountersGet(httpContext?: HttpContext, reportProgress?: boolean): Observable<DeactivatedUsersCounters> {

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<DeactivatedUsersCounters>(`${this.basePath}/auth/deactivate/deactivated_users_counters`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Logs previously registered user in
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthLoginPost(body: LoginRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<LoginResponse> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restAuthLoginPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<LoginResponse>(`${this.basePath}/auth/login`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Log out user from the currently open session
     * 
     
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthLogoutPost(httpContext?: HttpContext, reportProgress?: boolean): Observable<EmptyResponse> {

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<EmptyResponse>(`${this.basePath}/auth/logout`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Requests to prolong duration of the session (user activity on the client side)
     * 
     
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthProlongPost(httpContext?: HttpContext, reportProgress?: boolean): Observable<EmptyResponse> {

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<EmptyResponse>(`${this.basePath}/auth/prolong`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Request changed email verification
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthRequestChangedEmailVerificationPost(body: ResetPasswordBody, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restAuthRequestChangedEmailVerificationPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/auth/request_changed_email_verification`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Request one time code status
     * 
     
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthRequestOneTimeCodeGet(httpContext?: HttpContext, reportProgress?: boolean): Observable<OtpStatusResponse> {

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<OtpStatusResponse>(`${this.basePath}/auth/request_one_time_code`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Request one time code
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthRequestOneTimeCodePost(body: RequestOneTimeCode, httpContext?: HttpContext, reportProgress?: boolean): Observable<OtpStatusResponse> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restAuthRequestOneTimeCodePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<OtpStatusResponse>(`${this.basePath}/auth/request_one_time_code`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Resend verification email to user
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthResendVerificationEmailPost(body: ResetPasswordBody, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restAuthResendVerificationEmailPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/auth/resend_verification_email`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Reset password request - send email to user
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthResetPasswordPost(body: ResetPasswordBody, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restAuthResetPasswordPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/auth/reset_password`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Change password after email link
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthResetPasswordPut(body: ResetPasswordChangeBody, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restAuthResetPasswordPut.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/auth/reset_password`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Secure session with MFA
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthSecureSessionPut(body: SecureSession, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restAuthSecureSessionPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/auth/secure_session`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Registers new individual user in the system
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthSignupIndividualPost(body: SignupIndividualRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<UserId> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restAuthSignupIndividualPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<UserId>(`${this.basePath}/auth/signup/individual`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Registers new organization user in the system
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthSignupOrganizationPost(body: SignupOrganizationRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<UserId> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restAuthSignupOrganizationPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<UserId>(`${this.basePath}/auth/signup/organization`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Validate reset password token
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthValidateResetPasswordTokenPost(body: ValidateResetPasswordTokenBody, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restAuthValidateResetPasswordTokenPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/auth/validate_reset_password_token`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Validate signup invitation token
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthValidateSignupInvitationTokenPost(body: ValidateSignupInvitationTokenRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restAuthValidateSignupInvitationTokenPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/auth/validate_signup_invitation_token`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Verify email
     * 
     * @param userId User ID
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthVerifyEmailPut(userId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<EmptyResponse> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restAuthVerifyEmailPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<EmptyResponse>(`${this.basePath}/auth/${encodeURIComponent(String(userId))}/verify_email`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Verify one time code
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restAuthVerifyOneTimeCodePost(body: VerifyOneTimeCodeRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<OtpAttemptStatus> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restAuthVerifyOneTimeCodePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<OtpAttemptStatus>(`${this.basePath}/auth/verify_one_time_code`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Delete category
     * 
     * @param category_id Category ID
     * @param reportProgress flag to report request and response progress.
     */
    public restCategoriesCategoryDelete(category_id: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (category_id === null || category_id === undefined) {
            throw new Error('Required parameter category_id was null or undefined when calling restCategoriesCategoryDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/category/${encodeURIComponent(String(category_id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Update any category or subcategory
     * 
     * @param body * @param category_id Category ID
     * @param reportProgress flag to report request and response progress.
     */
    public restCategoriesCategoryPut(body: UpdateCategoryRequest, category_id: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<Category> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restCategoriesCategoryPut.');
        }

        if (category_id === null || category_id === undefined) {
            throw new Error('Required parameter category_id was null or undefined when calling restCategoriesCategoryPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Category>(`${this.basePath}/category/${encodeURIComponent(String(category_id))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Create charity focus
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restCategoriesCharityFocusPost(body: CreateCategoryRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<Category> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restCategoriesCharityFocusPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Category>(`${this.basePath}/charity_focus`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Get charity focuses
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restCategoriesCharityFocusesGet(offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<Categories> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Categories>(`${this.basePath}/charity_focuses`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Create disease
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restCategoriesDiseasePost(body: CreateCategoryRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<Category> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restCategoriesDiseasePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Category>(`${this.basePath}/disease`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Get diseases
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restCategoriesDiseasesGet(offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<Categories> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Categories>(`${this.basePath}/diseases`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Get specialties
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restCategoriesSpecialtiesGet(offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<Categories> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Categories>(`${this.basePath}/specialties`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Create specialty
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restCategoriesSpecialtyPost(body: CreateCategoryRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<Category> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restCategoriesSpecialtyPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Category>(`${this.basePath}/specialty`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Create subcategory
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restCategoriesSubcategoryPost(body: CreateSubcategoryRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<Category> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restCategoriesSubcategoryPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Category>(`${this.basePath}/subcategory`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View the parent and child position of a ccomment
     * 
     * @param commentId Comment ID* @param sort_comments Sorting criterias and sorting type for comments* @param sort_replies Sorting criterias and sorting type for replies
     * @param reportProgress flag to report request and response progress.
     */
    public restCommentPositionGet(commentId: string, sort_comments?: string, sort_replies?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<CommentPosition> {

        if (commentId === null || commentId === undefined) {
            throw new Error('Required parameter commentId was null or undefined when calling restCommentPositionGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (sort_comments !== undefined && sort_comments !== null) {
            queryParameters = queryParameters.set('sort_comments', <any>sort_comments);
        }
        if (sort_replies !== undefined && sort_replies !== null) {
            queryParameters = queryParameters.set('sort_replies', <any>sort_replies);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<CommentPosition>(`${this.basePath}/comment/${encodeURIComponent(String(commentId))}/position`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View the rely list by comments ID
     * 
     * @param commentId Comment ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sort_replies Sorting criterias and sorting type for replies
     * @param reportProgress flag to report request and response progress.
     */
    public restCommentReplyIndexPaginable(commentId: string, offset?: number, limit?: number, sort_replies?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<ListOfCommentReplies> {

        if (commentId === null || commentId === undefined) {
            throw new Error('Required parameter commentId was null or undefined when calling restCommentReplyIndexPaginable.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sort_replies !== undefined && sort_replies !== null) {
            queryParameters = queryParameters.set('sort_replies', <any>sort_replies);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ListOfCommentReplies>(`${this.basePath}/comment/${encodeURIComponent(String(commentId))}/reply`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Add comment reply to comment
     * 
     * @param body * @param commentId Comment ID
     * @param reportProgress flag to report request and response progress.
     */
    public restCommentReplyPost(body: ReplyCommentRequest, commentId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<ReplyComment> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restCommentReplyPost.');
        }

        if (commentId === null || commentId === undefined) {
            throw new Error('Required parameter commentId was null or undefined when calling restCommentReplyPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ReplyComment>(`${this.basePath}/comment/${encodeURIComponent(String(commentId))}/reply`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Delete the comment
     * 
     * @param commentId Comment ID
     * @param reportProgress flag to report request and response progress.
     */
    public restCommentsDelete(commentId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (commentId === null || commentId === undefined) {
            throw new Error('Required parameter commentId was null or undefined when calling restCommentsDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/comment/${encodeURIComponent(String(commentId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Remove multiple files or folders by entity descriptor id
     * 
     * @param file_descriptor_ids Multiple file descriptor ids* @param folder_descriptor_ids Multiple folder descriptor ids
     * @param reportProgress flag to report request and response progress.
     */
    public restFileStorageBulkDeleteDelete(file_descriptor_ids?: Array<string>, folder_descriptor_ids?: Array<string>, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (file_descriptor_ids) {
            file_descriptor_ids.forEach((element) => {
                queryParameters = queryParameters.append('file_descriptor_ids', <any>element);
            })
        }
        if (folder_descriptor_ids) {
            folder_descriptor_ids.forEach((element) => {
                queryParameters = queryParameters.append('folder_descriptor_ids', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/files/bulk_delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View file activity log
     * 
     * @param file_descriptor_id FileDescriptorID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc
     * @param reportProgress flag to report request and response progress.
     */
    public restFileStorageFileActivityLogIndex(file_descriptor_id: string, offset?: number, limit?: number, sorting?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<FileActivityLog> {

        if (file_descriptor_id === null || file_descriptor_id === undefined) {
            throw new Error('Required parameter file_descriptor_id was null or undefined when calling restFileStorageFileActivityLogIndex.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<FileActivityLog>(`${this.basePath}/files/${encodeURIComponent(String(file_descriptor_id))}/activity_log`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Remove file shareable link
     * 
     * @param file_descriptor_id FileDescriptorID
     * @param reportProgress flag to report request and response progress.
     */
    public restFileStorageFileShareableLinkDelete(file_descriptor_id: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (file_descriptor_id === null || file_descriptor_id === undefined) {
            throw new Error('Required parameter file_descriptor_id was null or undefined when calling restFileStorageFileShareableLinkDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/files/${encodeURIComponent(String(file_descriptor_id))}/shareable_link`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Generate shareable link
     * 
     * @param file_descriptor_id FileDescriptorID
     * @param reportProgress flag to report request and response progress.
     */
    public restFileStorageFileShareableLinkPut(file_descriptor_id: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<FileDescriptor> {

        if (file_descriptor_id === null || file_descriptor_id === undefined) {
            throw new Error('Required parameter file_descriptor_id was null or undefined when calling restFileStorageFileShareableLinkPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<FileDescriptor>(`${this.basePath}/files/${encodeURIComponent(String(file_descriptor_id))}/shareable_link`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Share file
     * 
     * @param body * @param file_descriptor_id FileDescriptorID
     * @param reportProgress flag to report request and response progress.
     */
    public restFileStorageFileSharingPut(body: ShareRequest, file_descriptor_id: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restFileStorageFileSharingPut.');
        }

        if (file_descriptor_id === null || file_descriptor_id === undefined) {
            throw new Error('Required parameter file_descriptor_id was null or undefined when calling restFileStorageFileSharingPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/files/${encodeURIComponent(String(file_descriptor_id))}/share`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View user files activity log
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc
     * @param reportProgress flag to report request and response progress.
     */
    public restFileStorageFilesActivityLogIndex(offset?: number, limit?: number, sorting?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<FilesActivityLog> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<FilesActivityLog>(`${this.basePath}/files/activity_log`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Remove file by file descriptor id
     * 
     * @param file_descriptor_id FileDescriptorID
     * @param reportProgress flag to report request and response progress.
     */
    public restFileStorageFilesDelete(file_descriptor_id: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (file_descriptor_id === null || file_descriptor_id === undefined) {
            throw new Error('Required parameter file_descriptor_id was null or undefined when calling restFileStorageFilesDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/files/${encodeURIComponent(String(file_descriptor_id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Move and rename file by file descriptor id
     * 
     * @param body * @param file_descriptor_id FileDescriptorID
     * @param reportProgress flag to report request and response progress.
     */
    public restFileStorageFilesPut(body: UpdateFileStorageItemRequest, file_descriptor_id: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restFileStorageFilesPut.');
        }

        if (file_descriptor_id === null || file_descriptor_id === undefined) {
            throw new Error('Required parameter file_descriptor_id was null or undefined when calling restFileStorageFilesPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/files/${encodeURIComponent(String(file_descriptor_id))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Remove folder by folder descriptor id
     * 
     * @param folder_descriptor_id FolderDescriptorID
     * @param reportProgress flag to report request and response progress.
     */
    public restFileStorageFolderDelete(folder_descriptor_id: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (folder_descriptor_id === null || folder_descriptor_id === undefined) {
            throw new Error('Required parameter folder_descriptor_id was null or undefined when calling restFileStorageFolderDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/folders/${encodeURIComponent(String(folder_descriptor_id))}/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View the folders and files list
     * 
     * @param folder_descriptor_id FolderDescriptorID
     * @param reportProgress flag to report request and response progress.
     */
    public restFileStorageFolderGet(folder_descriptor_id: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<FoldersResponse> {

        if (folder_descriptor_id === null || folder_descriptor_id === undefined) {
            throw new Error('Required parameter folder_descriptor_id was null or undefined when calling restFileStorageFolderGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<FoldersResponse>(`${this.basePath}/folders/${encodeURIComponent(String(folder_descriptor_id))}/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * 
     * 
     
     * @param reportProgress flag to report request and response progress.
     */
    public restFileStorageFolderGetRoot(httpContext?: HttpContext, reportProgress?: boolean): Observable<FoldersResponse> {

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<FoldersResponse>(`${this.basePath}/folders`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Create folder
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restFileStorageFolderPost(body: CreateFolderRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<FolderDescriptor> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restFileStorageFolderPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<FolderDescriptor>(`${this.basePath}/folders`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Update folder by folder descriptor id
     * 
     * @param body * @param folder_descriptor_id FolderDescriptorID
     * @param reportProgress flag to report request and response progress.
     */
    public restFileStorageFolderPut(body: UpdateFileStorageItemRequest, folder_descriptor_id: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restFileStorageFolderPut.');
        }

        if (folder_descriptor_id === null || folder_descriptor_id === undefined) {
            throw new Error('Required parameter folder_descriptor_id was null or undefined when calling restFileStorageFolderPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/folders/${encodeURIComponent(String(folder_descriptor_id))}/`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Share folder
     * 
     * @param body * @param folder_descriptor_id FolderDescriptorID
     * @param reportProgress flag to report request and response progress.
     */
    public restFileStorageFolderSharingPut(body: ShareRequest, folder_descriptor_id: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restFileStorageFolderSharingPut.');
        }

        if (folder_descriptor_id === null || folder_descriptor_id === undefined) {
            throw new Error('Required parameter folder_descriptor_id was null or undefined when calling restFileStorageFolderSharingPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/folders/${encodeURIComponent(String(folder_descriptor_id))}/share`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Generate file download url
     * 
     * @param file_descriptor_id FileDescriptorID
     * @param reportProgress flag to report request and response progress.
     */
    public restFileStorageGenerateDownloadFileUrlPost(file_descriptor_id: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<GenerateDownloadFileUrlResponse> {

        if (file_descriptor_id === null || file_descriptor_id === undefined) {
            throw new Error('Required parameter file_descriptor_id was null or undefined when calling restFileStorageGenerateDownloadFileUrlPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<GenerateDownloadFileUrlResponse>(`${this.basePath}/files/${encodeURIComponent(String(file_descriptor_id))}/download`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Create S3 file link
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restFileStorageGenerateFileUrlPost(body: GenerateFileRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<GenerateFileResponse> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restFileStorageGenerateFileUrlPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<GenerateFileResponse>(`${this.basePath}/files/generate`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * 
     * 
     
     * @param reportProgress flag to report request and response progress.
     */
    public restFileStorageSizeGet(httpContext?: HttpContext, reportProgress?: boolean): Observable<FileSizeResponse> {

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<FileSizeResponse>(`${this.basePath}/files/size`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Unshare files
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restFileStorageUnshareFilesPost(body: UnshareFilesRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restFileStorageUnshareFilesPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/files/unshare`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * 
     * 
     * @param params Stringified json data of search request
     * @param reportProgress flag to report request and response progress.
     */
    public restMapCovidGet(params: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<CovidMapData> {

        if (params === null || params === undefined) {
            throw new Error('Required parameter params was null or undefined when calling restMapCovidGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (params !== undefined && params !== null) {
            queryParameters = queryParameters.set('params', <any>params);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/gzip',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<CovidMapData>(`${this.basePath}/map/layer/covid_map`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * 
     * 
     * @param params Stringified json data of search request
     * @param reportProgress flag to report request and response progress.
     */
    public restMapCovidVaccinationsGet(params: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<CovidVaccinationsMapData> {

        if (params === null || params === undefined) {
            throw new Error('Required parameter params was null or undefined when calling restMapCovidVaccinationsGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (params !== undefined && params !== null) {
            queryParameters = queryParameters.set('params', <any>params);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/gzip',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<CovidVaccinationsMapData>(`${this.basePath}/map/layer/covid_vaccinations_map`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * 
     * 
     * @param params Stringified json data of search request
     * @param reportProgress flag to report request and response progress.
     */
    public restMapStatisticsGet(params: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<Statistics> {

        if (params === null || params === undefined) {
            throw new Error('Required parameter params was null or undefined when calling restMapStatisticsGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (params !== undefined && params !== null) {
            queryParameters = queryParameters.set('params', <any>params);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Statistics>(`${this.basePath}/statistics`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Unlink doctor by patient id
     * 
     * @param doctorLinkId Id of the doctor link to unlink
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalDoctorLinkDelete(doctorLinkId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (doctorLinkId === null || doctorLinkId === undefined) {
            throw new Error('Required parameter doctorLinkId was null or undefined when calling restMedicalDoctorLinkDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/medical/doctor_link/${encodeURIComponent(String(doctorLinkId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Accept or decline the doctor linking request
     * 
     * @param body * @param doctorLinkId Id of the doctor link to accept or reject invitation
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalDoctorLinkPut(body: ConnectionRequestAction, doctorLinkId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restMedicalDoctorLinkPut.');
        }

        if (doctorLinkId === null || doctorLinkId === undefined) {
            throw new Error('Required parameter doctorLinkId was null or undefined when calling restMedicalDoctorLinkPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/medical/doctor_link/${encodeURIComponent(String(doctorLinkId))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Doctor links counters
     * 
     
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalDoctorLinksCounters(httpContext?: HttpContext, reportProgress?: boolean): Observable<RequestCounters> {

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RequestCounters>(`${this.basePath}/medical/doctor_links/counters`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetch linked doctors for the current patient
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalDoctorLinksIndexLinked(offset?: number, limit?: number, sorting?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<DoctorLinkRequests> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<DoctorLinkRequests>(`${this.basePath}/medical/doctor_links/linked`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetch received doctor link
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalDoctorLinksIndexReceived(offset?: number, limit?: number, sorting?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<DoctorLinkRequests> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<DoctorLinkRequests>(`${this.basePath}/medical/doctor_links/received_requests`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetch linking requests to doctors
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalDoctorLinksIndexSent(offset?: number, limit?: number, sorting?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<DoctorLinkRequests> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<DoctorLinkRequests>(`${this.basePath}/medical/doctor_links/sent_requests`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Send the linking request to the doctor
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalDoctorLinksPost(body: MedicalDoctorLinksBody, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restMedicalDoctorLinksPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/medical/doctor_links`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * get user preferences
     * 
     * @param userId User ID
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalDoctorPreferencesGet(userId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<DoctorPreferences> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restMedicalDoctorPreferencesGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<DoctorPreferences>(`${this.basePath}/medical/${encodeURIComponent(String(userId))}/doctor/preferences`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Update user preferences
     * 
     * @param body * @param userId User ID
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalDoctorPreferencesPut(body: DoctorPreferences, userId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restMedicalDoctorPreferencesPut.');
        }

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restMedicalDoctorPreferencesPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/medical/${encodeURIComponent(String(userId))}/doctor/preferences`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Unlink patient by id
     * 
     * @param patientLinkId Id of the patient link to unlink
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalPatientLinkDelete(patientLinkId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (patientLinkId === null || patientLinkId === undefined) {
            throw new Error('Required parameter patientLinkId was null or undefined when calling restMedicalPatientLinkDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/medical/patient_link/${encodeURIComponent(String(patientLinkId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Accept or decline the linking request
     * 
     * @param body * @param patientLinkId Id of the patient link to unlink
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalPatientLinkPut(body: ConnectionRequestAction, patientLinkId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restMedicalPatientLinkPut.');
        }

        if (patientLinkId === null || patientLinkId === undefined) {
            throw new Error('Required parameter patientLinkId was null or undefined when calling restMedicalPatientLinkPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/medical/patient_link/${encodeURIComponent(String(patientLinkId))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Patient links counters
     * 
     
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalPatientLinksCounters(httpContext?: HttpContext, reportProgress?: boolean): Observable<RequestCounters> {

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RequestCounters>(`${this.basePath}/medical/patient_links/counters`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetch linked patients for the current doctor
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalPatientLinksIndexLinked(offset?: number, limit?: number, sorting?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<PatientLinkRequests> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PatientLinkRequests>(`${this.basePath}/medical/patient_links/linked`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetch linking requests to patients
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalPatientLinksIndexReceived(offset?: number, limit?: number, sorting?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<PatientLinkRequests> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PatientLinkRequests>(`${this.basePath}/medical/patient_links/received_requests`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetch linking requests to patients
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalPatientLinksIndexSent(offset?: number, limit?: number, sorting?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<PatientLinkRequests> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PatientLinkRequests>(`${this.basePath}/medical/patient_links/sent_requests`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Send the linking request to the patient
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalPatientLinksPost(body: MedicalPatientLinksBody, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restMedicalPatientLinksPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/medical/patient_links`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Get patients geography
     * 
     * @param userId User ID* @param filter_by Filter for patient distribution* @param filter_value Filter value for patient distribution
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalPatientsGeographyGet(userId: string, filter_by?: PatientDistributionFilter, filter_value?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<RelationGeography> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restMedicalPatientsGeographyGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filter_by !== undefined && filter_by !== null) {
            queryParameters = queryParameters.set('filter_by', <any>filter_by);
        }
        if (filter_value !== undefined && filter_value !== null) {
            queryParameters = queryParameters.set('filter_value', <any>filter_value);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RelationGeography>(`${this.basePath}/medical/${encodeURIComponent(String(userId))}/patients_geography`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetching all verified connections for current user
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc* @param filter_roles Role filtering parameter
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalProfileConnectionsIndexVerified(offset?: number, limit?: number, sorting?: string, filter_roles?: Array<string>, httpContext?: HttpContext, reportProgress?: boolean): Observable<Connections> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }
        if (filter_roles) {
            filter_roles.forEach((element) => {
                queryParameters = queryParameters.append('filter_roles', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Connections>(`${this.basePath}/social/profile/verified_connections`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetching all sent requests by current user
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc* @param filter_roles Role filtering parameter
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalProfileConnectionsRequestsIndex(offset?: number, limit?: number, sorting?: string, filter_roles?: Array<string>, httpContext?: HttpContext, reportProgress?: boolean): Observable<Connections> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }
        if (filter_roles) {
            filter_roles.forEach((element) => {
                queryParameters = queryParameters.append('filter_roles', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Connections>(`${this.basePath}/social/profile/sent_connections_requests`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetching all received requests for current user
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc* @param filter_roles Role filtering parameter
     * @param reportProgress flag to report request and response progress.
     */
    public restMedicalProfileConnectionsRequestsIndexReceived(offset?: number, limit?: number, sorting?: string, filter_roles?: Array<string>, httpContext?: HttpContext, reportProgress?: boolean): Observable<Connections> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }
        if (filter_roles) {
            filter_roles.forEach((element) => {
                queryParameters = queryParameters.append('filter_roles', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Connections>(`${this.basePath}/social/profile/received_connections_requests`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Get user notification preferences
     * 
     
     * @param reportProgress flag to report request and response progress.
     */
    public restNotificationsNotificationPreferencesGet(httpContext?: HttpContext, reportProgress?: boolean): Observable<ExtendedNotificationsContextPreferences> {

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ExtendedNotificationsContextPreferences>(`${this.basePath}/user/notification_preferences`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Update notification preferences
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restNotificationsNotificationPreferencesPut(body: Array<ContextPreferences>, httpContext?: HttpContext, reportProgress?: boolean): Observable<NotificationsContextPreferences> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restNotificationsNotificationPreferencesPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<NotificationsContextPreferences>(`${this.basePath}/user/notification_preferences`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Delete profile from the block list
     * 
     * @param userId User ID
     * @param reportProgress flag to report request and response progress.
     */
    public restProfileBlockDelete(userId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restProfileBlockDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/profile/${encodeURIComponent(String(userId))}/block`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetches data of all profile that user blocked
     * 
     * @param userId User ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restProfileBlockGet(userId: string, offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<ListOfExtendedUsers> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restProfileBlockGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ListOfExtendedUsers>(`${this.basePath}/profile/${encodeURIComponent(String(userId))}/blocked`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetches list of blocked users
     * 
     * @param userId User ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restProfileBlockIndex(userId: string, offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<PaginatableListOfExtendedUsers> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restProfileBlockIndex.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatableListOfExtendedUsers>(`${this.basePath}/profile/${encodeURIComponent(String(userId))}/blocked_users`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Add profile to the blocked list
     * 
     * @param userId User ID
     * @param reportProgress flag to report request and response progress.
     */
    public restProfileBlockPost(userId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<InlineResponse201> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restProfileBlockPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<InlineResponse201>(`${this.basePath}/profile/${encodeURIComponent(String(userId))}/block`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetches data of requested search aggregation items
     * 
     * @param params Stringifyied json data of search aggregation request
     * @param reportProgress flag to report request and response progress.
     */
    public restSearchAggregationsGet(params?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<SearchAggregationResponse> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (params !== undefined && params !== null) {
            queryParameters = queryParameters.set('params', <any>params);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SearchAggregationResponse>(`${this.basePath}/search/aggregations`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetches metadata of the attributes for search
     * 
     
     * @param reportProgress flag to report request and response progress.
     */
    public restSearchAttributesIndexGet(httpContext?: HttpContext, reportProgress?: boolean): Observable<SearchAttributesResponse> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SearchAttributesResponse>(`${this.basePath}/search/attributes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetches data of requested search items
     * 
     * @param params Stringifyied json data of search request
     * @param reportProgress flag to report request and response progress.
     */
    public restSearchResultsGet(params?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<SearchResponse> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (params !== undefined && params !== null) {
            queryParameters = queryParameters.set('params', <any>params);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SearchResponse>(`${this.basePath}/search/results`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Suggestion for autocomplete
     * 
     * @param entity Entity type, which can be auto-completed* @param text This is what we want auto-complete data for* @param exclude Entity ids to exclude suggestions for* @param sorting Suggestion sorting criteria i.e. Display Name, Created, etc...* @param ascending Ascending or descending sorting criteria* @param query_mode Suggestion query mode* @param limit The numbers of items to return* @param offset The number of items to skip before starting to collect the result set
     * @param reportProgress flag to report request and response progress.
     */
    public restSearchSuggestGet(entity: SuggestionItemTypes, text?: string, exclude?: Array<string>, sorting?: SortAttributeNames, ascending?: boolean, query_mode?: QueryMode, limit?: number, offset?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<SuggestionResponse> {

        if (entity === null || entity === undefined) {
            throw new Error('Required parameter entity was null or undefined when calling restSearchSuggestGet.');
        }








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (entity !== undefined && entity !== null) {
            queryParameters = queryParameters.set('entity', <any>entity);
        }
        if (text !== undefined && text !== null) {
            queryParameters = queryParameters.set('text', <any>text);
        }
        if (exclude) {
            exclude.forEach((element) => {
                queryParameters = queryParameters.append('exclude', <any>element);
            })
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }
        if (ascending !== undefined && ascending !== null) {
            queryParameters = queryParameters.set('ascending', <any>ascending);
        }
        if (query_mode !== undefined && query_mode !== null) {
            queryParameters = queryParameters.set('query_mode', <any>query_mode);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SuggestionResponse>(`${this.basePath}/search/suggest`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Suggestion for autocomplete
     * 
     * @param entity Entity type, which can be auto-completed* @param recent_action * @param text This is what we want auto-complete data for* @param query_mode Suggestion query mode* @param exclude Entity ids to exclude suggestions for* @param limit The numbers of items to return* @param offset The number of items to skip before starting to collect the result set
     * @param reportProgress flag to report request and response progress.
     */
    public restSearchSuggestRecentGet(entity: SuggestionItemTypes, recent_action: RecentAction, text?: string, query_mode?: QueryMode, exclude?: Array<string>, limit?: number, offset?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<SuggestionResponse> {

        if (entity === null || entity === undefined) {
            throw new Error('Required parameter entity was null or undefined when calling restSearchSuggestRecentGet.');
        }

        if (recent_action === null || recent_action === undefined) {
            throw new Error('Required parameter recent_action was null or undefined when calling restSearchSuggestRecentGet.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (entity !== undefined && entity !== null) {
            queryParameters = queryParameters.set('entity', <any>entity);
        }
        if (text !== undefined && text !== null) {
            queryParameters = queryParameters.set('text', <any>text);
        }
        if (query_mode !== undefined && query_mode !== null) {
            queryParameters = queryParameters.set('query_mode', <any>query_mode);
        }
        if (recent_action !== undefined && recent_action !== null) {
            queryParameters = queryParameters.set('recent_action', <any>recent_action);
        }
        if (exclude) {
            exclude.forEach((element) => {
                queryParameters = queryParameters.append('exclude', <any>element);
            })
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SuggestionResponse>(`${this.basePath}/search/suggest_recent`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View charity
     * 
     * @param communityId Community ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCharitiesGet(communityId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<CharityCommunity> {

        if (communityId === null || communityId === undefined) {
            throw new Error('Required parameter communityId was null or undefined when calling restSocialCharitiesGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<CharityCommunity>(`${this.basePath}/social/charity/${encodeURIComponent(String(communityId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Create a new community with charity focus
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCharitiesPost(body: CreateCharityRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<CharityCommunity> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restSocialCharitiesPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CharityCommunity>(`${this.basePath}/social/charities`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Edit charity
     * 
     * @param body * @param communityId Community ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCharitiesPut(body: UpdateCharityRequest, communityId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<CharityCommunity> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restSocialCharitiesPut.');
        }

        if (communityId === null || communityId === undefined) {
            throw new Error('Required parameter communityId was null or undefined when calling restSocialCharitiesPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<CharityCommunity>(`${this.basePath}/social/charity/${encodeURIComponent(String(communityId))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View all account involvements for community
     * 
     * @param communityId Community ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCommunitiesAccountInvolvements(communityId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<AccountInvolvements> {

        if (communityId === null || communityId === undefined) {
            throw new Error('Required parameter communityId was null or undefined when calling restSocialCommunitiesAccountInvolvements.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<AccountInvolvements>(`${this.basePath}/social/community/${encodeURIComponent(String(communityId))}/account_involvements`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Community counters
     * 
     * @param communityId Community ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCommunitiesCounters(communityId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<CommunityCounters> {

        if (communityId === null || communityId === undefined) {
            throw new Error('Required parameter communityId was null or undefined when calling restSocialCommunitiesCounters.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<CommunityCounters>(`${this.basePath}/social/community/${encodeURIComponent(String(communityId))}/counters`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Remove community
     * 
     * @param communityId Community ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCommunitiesDelete(communityId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<EmptyResponse> {

        if (communityId === null || communityId === undefined) {
            throw new Error('Required parameter communityId was null or undefined when calling restSocialCommunitiesDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<EmptyResponse>(`${this.basePath}/social/community/${encodeURIComponent(String(communityId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View community
     * 
     * @param communityId Community ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCommunitiesGet(communityId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<HealthCommunity> {

        if (communityId === null || communityId === undefined) {
            throw new Error('Required parameter communityId was null or undefined when calling restSocialCommunitiesGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<HealthCommunity>(`${this.basePath}/social/community/${encodeURIComponent(String(communityId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View all invitations to join communities
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCommunitiesGotInvitationsIndex(offset?: number, limit?: number, sorting?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<PaginatablePendingUserInvolvementsInCommunities> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatablePendingUserInvolvementsInCommunities>(`${this.basePath}/social/communities/invitations`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View all communities for current user
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCommunitiesIndex(offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<Communities> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Communities>(`${this.basePath}/social/communities`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Get counters for user communities social involvement
     * 
     
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCommunitiesInvolvementCountersGet(httpContext?: HttpContext, reportProgress?: boolean): Observable<RequestCounters> {

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RequestCounters>(`${this.basePath}/social/communities/involvement_counters`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Create a new community
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCommunitiesPost(body: CreateCommunityRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<HealthCommunity> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restSocialCommunitiesPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<HealthCommunity>(`${this.basePath}/social/communities`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Edit community
     * 
     * @param body * @param communityId Community ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCommunitiesPut(body: UpdateCommunityRequest, communityId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<HealthCommunity> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restSocialCommunitiesPut.');
        }

        if (communityId === null || communityId === undefined) {
            throw new Error('Required parameter communityId was null or undefined when calling restSocialCommunitiesPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<HealthCommunity>(`${this.basePath}/social/community/${encodeURIComponent(String(communityId))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View all sent requests to join communities
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCommunitiesSentRequestsIndex(offset?: number, limit?: number, sorting?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<PaginatablePendingUserInvolvementsInCommunities> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatablePendingUserInvolvementsInCommunities>(`${this.basePath}/social/communities/sent_requests`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetch all sent invitations by user for a specific community
     * 
     * @param communityId Community ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCommunityInvitesIndex(communityId: string, offset?: number, limit?: number, sorting?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<PaginatablePendingUserInvolvements> {

        if (communityId === null || communityId === undefined) {
            throw new Error('Required parameter communityId was null or undefined when calling restSocialCommunityInvitesIndex.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatablePendingUserInvolvements>(`${this.basePath}/social/community/${encodeURIComponent(String(communityId))}/sent_invitations`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Get counters for communities centric user involvement
     * 
     * @param communityId Community ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCommunityInvolvementCountersGet(communityId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<RequestCountersBasic> {

        if (communityId === null || communityId === undefined) {
            throw new Error('Required parameter communityId was null or undefined when calling restSocialCommunityInvolvementCountersGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RequestCountersBasic>(`${this.basePath}/social/community/${encodeURIComponent(String(communityId))}/involvement_counters`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Leave the community, remove a user from members
     * 
     * @param communityId Community ID* @param userId User ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCommunityMembersDelete(communityId: string, userId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<EmptyResponse> {

        if (communityId === null || communityId === undefined) {
            throw new Error('Required parameter communityId was null or undefined when calling restSocialCommunityMembersDelete.');
        }

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restSocialCommunityMembersDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<EmptyResponse>(`${this.basePath}/social/community/${encodeURIComponent(String(communityId))}/member/${encodeURIComponent(String(userId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View members list
     * 
     * @param communityId Community ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCommunityMembersIndex(communityId: string, offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<PaginatableListOfBasicUsers> {

        if (communityId === null || communityId === undefined) {
            throw new Error('Required parameter communityId was null or undefined when calling restSocialCommunityMembersIndex.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatableListOfBasicUsers>(`${this.basePath}/social/community/${encodeURIComponent(String(communityId))}/members`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Invite a user to the community, join the community, send request to join
     * 
     * @param body * @param communityId Community ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCommunityMembersPost(body: UserIdRequest, communityId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<EmptyResponse> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restSocialCommunityMembersPost.');
        }

        if (communityId === null || communityId === undefined) {
            throw new Error('Required parameter communityId was null or undefined when calling restSocialCommunityMembersPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EmptyResponse>(`${this.basePath}/social/community/${encodeURIComponent(String(communityId))}/members`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Community lead accepts join request to become the community member, or invited profile accepts lead&#x27;s invitation
     * 
     * @param body * @param communityId Community ID* @param userId User ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCommunityMembersPut(body: CommunityInviteOrDeclineRequest, communityId: string, userId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restSocialCommunityMembersPut.');
        }

        if (communityId === null || communityId === undefined) {
            throw new Error('Required parameter communityId was null or undefined when calling restSocialCommunityMembersPut.');
        }

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restSocialCommunityMembersPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/social/community/${encodeURIComponent(String(communityId))}/member/${encodeURIComponent(String(userId))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View posts list
     * 
     * @param communityId Community ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCommunityPostsIndex(communityId: string, offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<Posts> {

        if (communityId === null || communityId === undefined) {
            throw new Error('Required parameter communityId was null or undefined when calling restSocialCommunityPostsIndex.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Posts>(`${this.basePath}/social/community/${encodeURIComponent(String(communityId))}/posts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View projects list
     * 
     * @param communityId Community ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCommunityProjectsIndex(communityId: string, offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<Projects> {

        if (communityId === null || communityId === undefined) {
            throw new Error('Required parameter communityId was null or undefined when calling restSocialCommunityProjectsIndex.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Projects>(`${this.basePath}/social/community/${encodeURIComponent(String(communityId))}/projects`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetch all user requests to join a specific community
     * 
     * @param communityId Community ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialCommunityRequestsIndex(communityId: string, offset?: number, limit?: number, sorting?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<PaginatablePendingUserInvolvements> {

        if (communityId === null || communityId === undefined) {
            throw new Error('Required parameter communityId was null or undefined when calling restSocialCommunityRequestsIndex.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatablePendingUserInvolvements>(`${this.basePath}/social/community/${encodeURIComponent(String(communityId))}/requests`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Resets the title of the conversation
     * 
     * @param conversationId Conversation ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialConversationTitleDelete(conversationId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (conversationId === null || conversationId === undefined) {
            throw new Error('Required parameter conversationId was null or undefined when calling restSocialConversationTitleDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/social/conversations/${encodeURIComponent(String(conversationId))}/title`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Updates the title of the conversation
     * 
     * @param body * @param conversationId Conversation ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialConversationTitlePut(body: UpdateConversationTitleRequest, conversationId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restSocialConversationTitlePut.');
        }

        if (conversationId === null || conversationId === undefined) {
            throw new Error('Required parameter conversationId was null or undefined when calling restSocialConversationTitlePut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/social/conversations/${encodeURIComponent(String(conversationId))}/title`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Creates a conversation
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialConversationsPost(body: CreateConversationRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<Conversation> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restSocialConversationsPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Conversation>(`${this.basePath}/social/conversations`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Contact site owners
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialFeedbackPost(body: AddFeedbackRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restSocialFeedbackPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/feedback`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View comments list
     * 
     * @param postId POST ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sort_comments Sorting criterias and sorting type for comments* @param sort_replies Sorting criterias and sorting type for replies* @param replyLimit The numbers of comment reply items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialPostCommentsIndexList(postId: string, offset?: number, limit?: number, sort_comments?: string, sort_replies?: string, replyLimit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<ListOfRootComments> {

        if (postId === null || postId === undefined) {
            throw new Error('Required parameter postId was null or undefined when calling restSocialPostCommentsIndexList.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sort_comments !== undefined && sort_comments !== null) {
            queryParameters = queryParameters.set('sort_comments', <any>sort_comments);
        }
        if (sort_replies !== undefined && sort_replies !== null) {
            queryParameters = queryParameters.set('sort_replies', <any>sort_replies);
        }
        if (replyLimit !== undefined && replyLimit !== null) {
            queryParameters = queryParameters.set('replyLimit', <any>replyLimit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ListOfRootComments>(`${this.basePath}/social/post/${encodeURIComponent(String(postId))}/comments_list`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Add a comment
     * 
     * @param body * @param postId POST ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialPostCommentsPost(body: CreateCommentRequest, postId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<RootComment> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restSocialPostCommentsPost.');
        }

        if (postId === null || postId === undefined) {
            throw new Error('Required parameter postId was null or undefined when calling restSocialPostCommentsPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<RootComment>(`${this.basePath}/social/post/${encodeURIComponent(String(postId))}/comments`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Remove post
     * 
     * @param postId POST ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialPostsDelete(postId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<EmptyResponse> {

        if (postId === null || postId === undefined) {
            throw new Error('Required parameter postId was null or undefined when calling restSocialPostsDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<EmptyResponse>(`${this.basePath}/social/post/${encodeURIComponent(String(postId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View post
     * 
     * @param postId POST ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialPostsGet(postId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<Post> {

        if (postId === null || postId === undefined) {
            throw new Error('Required parameter postId was null or undefined when calling restSocialPostsGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Post>(`${this.basePath}/social/post/${encodeURIComponent(String(postId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Create a new post
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialPostsPost(body: CreatePostRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<Post> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restSocialPostsPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Post>(`${this.basePath}/social/posts`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Edit post
     * 
     * @param body * @param postId POST ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialPostsPut(body: UpdatePostRequest, postId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<Post> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restSocialPostsPut.');
        }

        if (postId === null || postId === undefined) {
            throw new Error('Required parameter postId was null or undefined when calling restSocialPostsPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Post>(`${this.basePath}/social/post/${encodeURIComponent(String(postId))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Profile connections counters by status
     * 
     
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProfileConnectionsCounters(httpContext?: HttpContext, reportProgress?: boolean): Observable<RequestCounters> {

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RequestCounters>(`${this.basePath}/social/profile/connections_counters`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Remove connection by account id
     * 
     * @param userId User ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProfileConnectionsDelete(userId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restSocialProfileConnectionsDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/social/profile/connection/${encodeURIComponent(String(userId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetching a foreign user&#x27;s connection requests (Admin only)
     * 
     * @param userId User ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProfileConnectionsIndexForeignVerified(userId: string, offset?: number, limit?: number, sorting?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<Connections> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restSocialProfileConnectionsIndexForeignVerified.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Connections>(`${this.basePath}/social/profile/verified_connections/${encodeURIComponent(String(userId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Add connection to current user by account id
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProfileConnectionsPost(body: ProfileConnectionsBody, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restSocialProfileConnectionsPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/social/profile/connections`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Accept or decline connection by account id
     * 
     * @param body * @param userId User ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProfileConnectionsPut(body: ConnectionRequestAction, userId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restSocialProfileConnectionsPut.');
        }

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restSocialProfileConnectionsPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/social/profile/connection/${encodeURIComponent(String(userId))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetching a foreign user&#x27;s sent connection requests (Admin only)
     * 
     * @param userId User ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProfileConnectionsRequestsIndexForeign(userId: string, offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<Connections> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restSocialProfileConnectionsRequestsIndexForeign.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Connections>(`${this.basePath}/social/profile/sent_connections_requests/${encodeURIComponent(String(userId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetching a foreign user&#x27;s connection requests received (Admin only)
     * 
     * @param userId User ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProfileConnectionsRequestsIndexForeignReceived(userId: string, offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<Connections> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restSocialProfileConnectionsRequestsIndexForeignReceived.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Connections>(`${this.basePath}/social/profile/received_connections_requests/${encodeURIComponent(String(userId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Logs the current user into messaging external service and returns access token for client SDK
     * 
     
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProfileMessagingAccessPost(httpContext?: HttpContext, reportProgress?: boolean): Observable<MessagingAccessToken> {

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<MessagingAccessToken>(`${this.basePath}/social/profile/messaging/access`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Returns data of current&#x27;s profile individual messaging channel for system notifications
     * 
     
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProfileMessagingNotifyChannelGet(httpContext?: HttpContext, reportProgress?: boolean): Observable<MessagingChannelBasic> {

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MessagingChannelBasic>(`${this.basePath}/social/profile/messaging/notify_channel`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetch all posts by userId
     * 
     * @param userId User ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProfilePostsIndex(userId: string, offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<Posts> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restSocialProfilePostsIndex.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Posts>(`${this.basePath}/social/profile/${encodeURIComponent(String(userId))}/posts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View the project invited and pending owners list
     * 
     * @param projectId Project ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectLeadersIndexPending(projectId: string, offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<PaginatablePendingUserInvolvements> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling restSocialProjectLeadersIndexPending.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatablePendingUserInvolvements>(`${this.basePath}/social/project/${encodeURIComponent(String(projectId))}/owners/invitations`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Leave the project, remove a user from members
     * 
     * @param projectId Project ID* @param userId User ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectMembersDelete(projectId: string, userId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<EmptyResponse> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling restSocialProjectMembersDelete.');
        }

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restSocialProjectMembersDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<EmptyResponse>(`${this.basePath}/social/project/${encodeURIComponent(String(projectId))}/member/${encodeURIComponent(String(userId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View members list
     * 
     * @param projectId Project ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectMembersIndex(projectId: string, offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<PaginatableListOfBasicUsers> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling restSocialProjectMembersIndex.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatableListOfBasicUsers>(`${this.basePath}/social/project/${encodeURIComponent(String(projectId))}/members`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View the project pending invited participants list
     * 
     * @param projectId Project ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectMembersIndexPending(projectId: string, offset?: number, limit?: number, sorting?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<PaginatablePendingUserInvolvements> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling restSocialProjectMembersIndexPending.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatablePendingUserInvolvements>(`${this.basePath}/social/project/${encodeURIComponent(String(projectId))}/participants/invitations`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View the project pending requested participants list
     * 
     * @param projectId Project ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectMembersIndexRequests(projectId: string, offset?: number, limit?: number, sorting?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<PaginatablePendingUserInvolvements> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling restSocialProjectMembersIndexRequests.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatablePendingUserInvolvements>(`${this.basePath}/social/project/${encodeURIComponent(String(projectId))}/participants/requests`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View the project pending invitation and requests counters
     * 
     * @param projectId Project ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectMembersInvolvementCounters(projectId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<RequestCountersBasic> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling restSocialProjectMembersInvolvementCounters.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RequestCountersBasic>(`${this.basePath}/social/project/${encodeURIComponent(String(projectId))}/participants/involvement_counters`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Invite a user to the project, join the project, send request to join
     * 
     * @param body * @param projectId Project ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectMembersPost(body: UserIdRequest, projectId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<EmptyResponse> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restSocialProjectMembersPost.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling restSocialProjectMembersPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EmptyResponse>(`${this.basePath}/social/project/${encodeURIComponent(String(projectId))}/members`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * User accept or reject invitation to become the project member
     * 
     * @param body * @param projectId Project ID* @param userId User ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectMembersPut(body: ProjectInviteOrDeclineRequest, projectId: string, userId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<EmptyResponse> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restSocialProjectMembersPut.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling restSocialProjectMembersPut.');
        }

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restSocialProjectMembersPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<EmptyResponse>(`${this.basePath}/social/project/${encodeURIComponent(String(projectId))}/member/${encodeURIComponent(String(userId))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View posts list
     * 
     * @param projectId Project ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectPostsIndex(projectId: string, offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<Posts> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling restSocialProjectPostsIndex.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Posts>(`${this.basePath}/social/project/${encodeURIComponent(String(projectId))}/posts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View all account involvements for projects
     * 
     * @param projectId Project ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectsAccountInvolvements(projectId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<AccountInvolvements> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling restSocialProjectsAccountInvolvements.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<AccountInvolvements>(`${this.basePath}/social/project/${encodeURIComponent(String(projectId))}/account_involvements`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Project counters
     * 
     * @param projectId Project ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectsCounters(projectId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<SocialGroupCountersBasic> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling restSocialProjectsCounters.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SocialGroupCountersBasic>(`${this.basePath}/social/project/${encodeURIComponent(String(projectId))}/counters`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Remove project
     * 
     * @param projectId Project ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectsDelete(projectId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<EmptyResponse> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling restSocialProjectsDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<EmptyResponse>(`${this.basePath}/social/project/${encodeURIComponent(String(projectId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View project
     * 
     * @param projectId Project ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectsGet(projectId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<Project> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling restSocialProjectsGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Project>(`${this.basePath}/social/project/${encodeURIComponent(String(projectId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View projects of current user
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectsIndex(offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<Projects> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Projects>(`${this.basePath}/social/projects`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View the user&#x27;s invited as member projects list
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectsInvitationsIndex(offset?: number, limit?: number, sorting?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<PaginatablePendingUserInvolvementsInProjects> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatablePendingUserInvolvementsInProjects>(`${this.basePath}/social/projects/invitations`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View the user&#x27;s invited as owner projects list
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectsInvitationsIndexOwners(offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<PaginatablePendingUserInvolvementsInProjects> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatablePendingUserInvolvementsInProjects>(`${this.basePath}/social/projects/owner/invitations`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Get counters for user projects social involvement
     * 
     
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectsInvolvementCountersGet(httpContext?: HttpContext, reportProgress?: boolean): Observable<RequestCounters> {

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RequestCounters>(`${this.basePath}/social/projects/involvement_counters`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Create a new project
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectsPost(body: CreateProjectRequest, httpContext?: HttpContext, reportProgress?: boolean): Observable<Project> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restSocialProjectsPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Project>(`${this.basePath}/social/projects`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Edit project
     * 
     * @param body * @param projectId Project ID
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectsPut(body: UpdateProjectRequest, projectId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<Project> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restSocialProjectsPut.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling restSocialProjectsPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Project>(`${this.basePath}/social/project/${encodeURIComponent(String(projectId))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View the user&#x27;s requested projects list
     * 
     * @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return* @param sorting Sorting order param, default is name_asc
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialProjectsRequestsIndex(offset?: number, limit?: number, sorting?: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<PaginatablePendingUserInvolvementsInProjects> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sorting !== undefined && sorting !== null) {
            queryParameters = queryParameters.set('sorting', <any>sorting);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatablePendingUserInvolvementsInProjects>(`${this.basePath}/social/projects/requests`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View related communities
     * 
     * @param communityId Community ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialRelatedCommunitiesIndex(communityId: string, offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<CommunitiesBasic> {

        if (communityId === null || communityId === undefined) {
            throw new Error('Required parameter communityId was null or undefined when calling restSocialRelatedCommunitiesIndex.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<CommunitiesBasic>(`${this.basePath}/social/community/${encodeURIComponent(String(communityId))}/related_communities`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View related projects
     * 
     * @param projectId Project ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialRelatedProjectsIndex(projectId: string, offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<ProjectsBasic> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling restSocialRelatedProjectsIndex.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ProjectsBasic>(`${this.basePath}/social/project/${encodeURIComponent(String(projectId))}/related_projects`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View communities of specific user
     * 
     * @param userId User ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialUserCommunitiesIndex(userId: string, offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<Communities> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restSocialUserCommunitiesIndex.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Communities>(`${this.basePath}/social/${encodeURIComponent(String(userId))}/communities`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View stats on current user&#x27;s social groups
     * 
     
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialUserGroupsStatsGet(httpContext?: HttpContext, reportProgress?: boolean): Observable<UserSocialGroupsStats> {

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<UserSocialGroupsStats>(`${this.basePath}/social/user_groups/stats`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * View projects of specific user
     * 
     * @param userId User ID* @param offset The number of items to skip before starting to collect the result set* @param limit The numbers of items to return
     * @param reportProgress flag to report request and response progress.
     */
    public restSocialUserProjectsIndex(userId: string, offset?: number, limit?: number, httpContext?: HttpContext, reportProgress?: boolean): Observable<Projects> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restSocialUserProjectsIndex.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Projects>(`${this.basePath}/social/${encodeURIComponent(String(userId))}/projects`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Change password
     * 
     * @param body 
     * @param reportProgress flag to report request and response progress.
     */
    public restUserChangePasswordPost(body: UserChangePassword, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restUserChangePasswordPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/user/change_password`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Deletes the specified user
     * 
     * @param userId User ID
     * @param reportProgress flag to report request and response progress.
     */
    public restUserDelete(userId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restUserDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/users/${encodeURIComponent(String(userId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetches the specified user&#x27;s information from all contexts
     * 
     * @param userId User ID
     * @param reportProgress flag to report request and response progress.
     */
    public restUserGet(userId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<FullUser> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restUserGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<FullUser>(`${this.basePath}/users/${encodeURIComponent(String(userId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetches all counsel users by type
     * 
     * @param counsel_role Fetches all counsel users
     * @param reportProgress flag to report request and response progress.
     */
    public restUserGetCounsel(counsel_role?: CounselRole, httpContext?: HttpContext, reportProgress?: boolean): Observable<CounselUsersByType> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (counsel_role !== undefined && counsel_role !== null) {
            queryParameters = queryParameters.set('counsel_role', <any>counsel_role);
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<CounselUsersByType>(`${this.basePath}/users/counsel`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Fetches all users
     * 
     * @param user_ids User IDs
     * @param reportProgress flag to report request and response progress.
     */
    public restUserIndex(user_ids: Array<string>, httpContext?: HttpContext, reportProgress?: boolean): Observable<ListOfBasicUsers> {

        if (user_ids === null || user_ids === undefined) {
            throw new Error('Required parameter user_ids was null or undefined when calling restUserIndex.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (user_ids) {
            user_ids.forEach((element) => {
                queryParameters = queryParameters.append('user_ids', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ListOfBasicUsers>(`${this.basePath}/users`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * Updates the specified user
     * 
     * @param body * @param userId User ID
     * @param reportProgress flag to report request and response progress.
     */
    public restUserPut(body: FullUserUpdateRequest, userId: string, httpContext?: HttpContext, reportProgress?: boolean): Observable<FullUser> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restUserPut.');
        }

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling restUserPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (session) required
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<FullUser>(`${this.basePath}/users/${encodeURIComponent(String(userId))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

    /**
     * 
     * 
     
     * @param reportProgress flag to report request and response progress.
     */
    public restUtilsHealthGet(httpContext?: HttpContext, reportProgress?: boolean): Observable<Health> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Health>(`${this.basePath}/health`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: 'body',
                reportProgress: reportProgress,
                context: httpContext
            }
        );
    }

}
